import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import {
  type SystemV1MessageConversionEventsResponse,
  systemV1MessageConversionEvents,
} from '@/api/generated';
import { oursIdentify } from '@/lib/ours';

type MutationParams = {
  eventName: 'Schedule' | 'CompleteRegistration';
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
};

export function useConversionEventsMutation(
  options?: UseMutationOptions<SystemV1MessageConversionEventsResponse, Error, MutationParams>
) {
  return useMutation({
    // Identify (not track) so the Python task's server-side Schedule/CompleteRegistration event stitches onto the visitor record without firing a duplicate client-side event to Meta/Google.
    onMutate: (params) => {
      oursIdentify({
        email: params.email,
        first_name: params.firstName,
        last_name: params.lastName,
        phone_number: params.phoneNumber,
      });
    },
    mutationFn: async (params) => {
      const { data } = await systemV1MessageConversionEvents({
        body: {
          event_name: params.eventName,
          first_name: params.firstName,
          last_name: params.lastName,
          email: params.email,
          phone_number: params.phoneNumber,
        },
      });

      return data;
    },
    ...options,
  });
}
